export { DOCUMENT_TYPE } from "./documentType";
export { default as documentTypeIconMap } from "./documentType.iconMap";
export { default as documentTypePreviewImageMap } from "./documentType.previewImageMap";
